import { SLIDE_TEMPLATES, SlideTypeEnum, ShowInSubNav, ProductsDisplayMode } from '../enums';
// ESP UPGRADE 17 type Condition = null;
import { Condition } from 'src/app/requests/esp/profile-customization/Model/CustomFieldModel';

export class SlideModel {
  CategoryId: string;
  Order?: number;
  SlideContent: SlideContentModel;
  ShowOnTop?: number;
  SlideId?: string;
  SlideName?: string;
  SlideShowIn?: string;
  SlideType?: string;
  ParentSectionId?: string;
  IsActive?: boolean;
  FromParent?: boolean;
  AlternateSlideBehavior?: string;
  AlternateSlideVisibleBy?: string;
  AlternateSlideIdOf?: string;
  constructor(value?: any) {
    if (!value) {
      // this.SlideContent = new SlideContentModel()
      return;
    }
    this.AlternateSlideBehavior = value?.AlternateSlideBehavior ?? null;
    this.AlternateSlideVisibleBy = value?.AlternateSlideVisibleBy ?? null;
    this.AlternateSlideIdOf = value?.AlternateSlideIdOf ?? null;
    this.CategoryId = value.CategoryId;
    this.Order = value.Order;
    this.SlideContent = value.SlideContent ? new SlideContentModel(JSON.parse(value.SlideContent)) : new SlideContentModel()
    this.SlideShowIn = value.SlideShowIn ?? '';
    this.SlideId = value.SlideId;
    this.ShowOnTop = value.ShowOnTop;
    this.FromParent = value.FromParent;
    this.IsActive = value.IsActive == null ? true : value.IsActive;
    this.ParentSectionId = value.ParentSectionId;
    this.SlideName = value.SlideName;
    this.SlideType = value.SlideType;
    if (this.SlideType == SLIDE_TEMPLATES.WITH_IMAGE) {
      Object.assign(this.SlideContent, new SimpleSlideContentModel(this.SlideContent))
    }
    if (this.SlideType == SlideTypeEnum.SIMPLE_SLIDE) {
      if (this.SlideContent.Image) {
        if (!this.SlideContent.Text &&
          !this.SlideContent.IsPrimaryButton &&
          !this.SlideContent.Action?.Label && !this.SlideContent?.Action?.Url &&
          !this.SlideContent.Action2?.Label && !this.SlideContent.Action2?.Url) {
          this.SlideType = SLIDE_TEMPLATES.IMAGE
        } else {
          this.SlideType = SLIDE_TEMPLATES.WITH_IMAGE
        }
      } else {
        this.SlideType = SLIDE_TEMPLATES.WITHOUT_IMAGE
      }
      Object.assign(this.SlideContent, new SimpleSlideContentModel(this.SlideContent))
    }
    if (this.SlideType == SlideTypeEnum.PRICE_SLIDE) {
      Object.assign(this.SlideContent, new PriceSlideContentModel(this.SlideContent))
    }
    if (this.SlideType == SlideTypeEnum.SECTION) {
      if (this.SlideContent.RenderType == "Link" || this.SlideContent.RenderType == "Collapsed") {
        this.SlideType = SLIDE_TEMPLATES.SLIDE_GROUP;
        Object.assign(this.SlideContent, new SlideGroupContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "Carousel") {
        this.SlideType = SLIDE_TEMPLATES.CAROUSEL_GROUP
        Object.assign(this.SlideContent, new CarouselGroupContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "Card") {
        this.SlideType = SLIDE_TEMPLATES.CARD_GROUP
        Object.assign(this.SlideContent, new CardGroupContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "Price") {
        this.SlideType = SLIDE_TEMPLATES.PRICE_GROUP
        Object.assign(this.SlideContent, new PriceGroupContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "Gallery") {
        this.SlideType = SLIDE_TEMPLATES.GALLERY_SLIDE
        Object.assign(this.SlideContent, new PriceGroupContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "News") {
        this.SlideType = SLIDE_TEMPLATES.NEWS_SLIDE
        Object.assign(this.SlideContent, new PriceGroupContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "StepSlide") {
        this.SlideType = SLIDE_TEMPLATES.STEPS_SLIDE
        Object.assign(this.SlideContent, new PriceGroupContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "PresentationSlide") {
        this.SlideType = SLIDE_TEMPLATES.PRESENTATION_SLIDE
        Object.assign(this.SlideContent, new SimpleSlideContentModel(this.SlideContent))
      } else if (this.SlideContent.RenderType == "TableSlide") {
        this.SlideType = SLIDE_TEMPLATES.TABLE_SLIDE
        Object.assign(this.SlideContent, new SimpleSlideContentModel(this.SlideContent))
      }
    } else {
      if (this.SlideType == SLIDE_TEMPLATES.CONTACT) {
        Object.assign(this.SlideContent, new ContactSlideContentModel(this.SlideContent))
      }
      if (this.SlideType == SLIDE_TEMPLATES.RICH_TEXT) {
        this.SlideName = 'Rich Text';
        Object.assign(this.SlideContent, new RichTextSlideContentModel(this.SlideContent))
      }
      if (this.SlideType == SLIDE_TEMPLATES.ESP_PROCESS) {
        Object.assign(this.SlideContent, new EspSlideContentModel(this.SlideContent))
      }
      if (this.SlideType == SLIDE_TEMPLATES.PRESENTATION_SLIDE) {
        this.SlideType = SLIDE_TEMPLATES.PRESENTATION_SLIDE
        Object.assign(this.SlideContent, new SimpleSlideContentModel(this.SlideContent))
      }
      if (this.SlideType == SLIDE_TEMPLATES.TABLE_SLIDE) {
        this.SlideType = SLIDE_TEMPLATES.TABLE_SLIDE
        Object.assign(this.SlideContent, new SimpleSlideContentModel(this.SlideContent))
      }
      if (this.SlideType == SLIDE_TEMPLATES.HIGHER_SLIDE) {
        this.SlideType = SLIDE_TEMPLATES.HIGHER_SLIDE
        Object.assign(this.SlideContent, new SimpleSlideContentModel(this.SlideContent))
      }
    }

  }
}


export class SlideContentModel {
  Action?: {
    Label: string,
    Url: string,
    Style?: string
  };
  Action2?: {
    Label: string,
    Url: string,
    Style?: string
  };
  TagIds?: string;
  columns?: any[] = [];
  rows?: any[] = [];
  actions?: any[] = [];
  id?: number;
  name?: string;
  type?: string;
  conditions: Condition[];
  noMemberDefinition: boolean = true;
  noOfPageRows?: number;
  domain?: string;
  baseurl?: string;
  orgid?: string;
  Title?: string;
  ImageHeight?: string;
  SubTitle?: string;
  Text?: string;
  UrlName?: string;
  urlName?: string;
  Bold?: string;
  IsPrimaryButton?: boolean;
  ShowInSubNav?: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;
  RenderType?: 'Link' | 'Carousel' | 'Collapsed' | 'Card' | 'Price' | 'Gallery' | 'News' | 'StepSlide' | 'PresentationSlide' | 'TableSlide';
  CardView?: CardViewEnum;
  DescriptionBehavior?: DescriptionBehaviorEnum;
  DefaultView?: 'Grid' | 'Scroll';
  Layout?: SlideLayoutEnum;
  ItemPerRow?: string;
  AlignText?: AlignTextEnum;
  BackgroundColor?: string;
  ImageDesign?: BackGroundImageDesign;
  SocialMediaId?: string;
  UserId?: string;
  URL?: string;
  Subtype?: string;
  ImageAlign?: ImageAlignOptions;
  ImageLayout?: ImageLayoutEnum;
  Image?: {
    AttachementID: string,
    Name: string,
    Location: string,
    URL: string,
    FileSize: number,
    FileExtension: string,
    Resolution: string,
    PreviewName: string,
    Deleted: boolean
  };
  Images?: string;
  Orientation?: 'Horizontal' | 'Vertical' | 'Top';
  MaxOutside: number | null;
  VideoLink?: string;
  MaxRows: any | null;
  CardsPerRow: any | null;
  Idenedi: string;
  email?: string;
  phone?: string;
  whatsapp?: string;
  website?: string;
  chatPersonName?: string;
  chatPersonIdenedi?: string;
  location?: {
    Label?: string,
    Url?: string
  };
  // for pricing
  Description?: string;
  ActionLabel?: string;
  ActionUrl?: string;
  Unit?: string;
  Currency?: string;
  Amount?: number;
  Features?: string;
  isRecommended?: boolean;
  ImageOverlay?: '1' | '0';
  TextMode?: 'light' | 'dark';
  TextArea?: 'full' | 'left' | 'right';
  Action3?: {
    Label: string,
    Url: string
  };
  Steps?: any;
  BulletType?: string;
  ShowOnTop?: boolean;
  HigherSlide?: any;
  ViewOn?: string;
  ViewModes?: SlideContentViewMode[]

  constructor(prop?: any) {
    Object.assign(this, prop);
  }
}

export class SlideContentViewMode {
  key: ProductsDisplayMode;
  value: string;
  checked: boolean;
  isDefault: boolean
}

export class Step {
  Icon?: number;  // Represents the icon, e.g., "xcdrs-settings"
  Text: string;  // Represents the text, e.g., "Text begins on a new line (indent first line)."
  Title: string; // Represents the title, e.g., "Centered, Bold, Title Case"
}


//Used for Slide With Image, Only Image, Only Without Image, Card Inner Slide, Carousel Inner Slide
export class SimpleSlideContentModel {
  Action: {
    Label: string,
    Url: string,
    Style?: string
  };
  Action2: {
    Label: string,
    Url: string,
    Style?: string
  };
  Title: string;
  SubTitle: string;
  Text: string;
  IsPrimaryButton: boolean;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  BackgroundColor?: string;
  ImageDesign?: BackGroundImageDesign;
  SubNavTitle?: string;
  Image: {
    AttachementID: string,
    Name: string,
    Location: string,
    URL: string,
    FileSize: number,
    FileExtension: string,
    Resolution: string,
    PreviewName: string,
    Deleted: boolean
  };
  Action3?: {
    Label: string,
    Url: string
  };
  AlignText?: AlignTextEnum;
  Layout?: SlideLayoutEnum;
  ImageOverlay?: '1' | '0';
  TextMode?: 'light' | 'dark';
  TextArea?: 'full' | 'left' | 'right';
  constructor(prop?: any) {
    if (!prop) {
      this.Action = { Label: '', Url: '' },
        this.Action2 = { Label: '', Url: '' },
        this.Image = {
          AttachementID: '',
          Name: '',
          Location: '',
          URL: '',
          FileSize: 0,
          FileExtension: '',
          Resolution: '',
          PreviewName: '',
          Deleted: false
        }
      return;
    }
    this.Action = (prop.Action) ? prop.Action : { Label: '', Url: '', Style: '' };
    this.Action2 = (prop.Action2) ? prop.Action2 : { Label: '', Url: '', Style: '' };
    this.Title = prop.Title;
    this.SubTitle = prop.SubTitle;
    this.Text = prop.Text;
    this.Image = prop.Image ?? {
      AttachementID: '',
      Name: '',
      Location: '',
      URL: '',
      FileSize: 0,
      FileExtension: '',
      Resolution: '',
      PreviewName: '',
      Deleted: false
    };
    this.BackgroundColor = prop.BackgroundColor;
    this.ImageDesign = prop?.ImageDesign;
    this.IsPrimaryButton = prop.IsPrimaryButton;
    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop?.SubNavTitle;
    this.Layout = prop?.Layout;
    this.AlignText = prop?.AlignText ?? AlignTextEnum.Default;
    this.TextArea = prop?.TextArea;
    this.TextMode = prop?.TextMode;
    this.Action3 = (prop?.Action3) ? prop.Action3 : { Label: '', Url: '' };
    this.ImageOverlay = prop?.ImageOverlay
  }
}

export class RichTextSlideContentModel {
  Title: string;
  SubTitle: string;
  Text: string;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;
  Action: {
    Label: string,
    Url: string,
    Style?: string
  };
  Action2: {
    Label: string,
    Url: string,
    Style?: string
  };
  Image: {
    AttachementID: string,
    Name: string,
    Location: string,
    URL: string,
    FileSize: number,
    FileExtension: string,
    Resolution: string,
    PreviewName: string,
    Deleted: boolean
  };
  Layout?: SlideLayoutEnum;

  constructor(prop?: any) {
    if (!prop) {
      this.Action = { Label: '', Url: '' },
        this.Action2 = { Label: '', Url: '' },
        this.Image = {
          AttachementID: '',
          Name: '',
          Location: '',
          URL: '',
          FileSize: 0,
          FileExtension: '',
          Resolution: '',
          PreviewName: '',
          Deleted: false
        }
      return;
    }

    this.Image = prop.Image ?? {
      AttachementID: '',
      Name: '',
      Location: '',
      URL: '',
      FileSize: 0,
      FileExtension: '',
      Resolution: '',
      PreviewName: '',
      Deleted: false
    };
    this.Title = prop?.Title || '';
    this.SubTitle = prop?.SubTitle || '';
    this.Action = (prop.Action) ? prop.Action : { Label: '', Url: '', Style: '' };
    this.Action2 = (prop.Action2) ? prop.Action2 : { Label: '', Url: '', Style: '' };
    this.Text = prop.Text;
    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop?.SubNavTitle;
    // this.Layout = SlideLayoutEnum.SSVertical;
  }
}

export class SlideGroupContentModel {
  Title: string;
  SubTitle: string;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;
  RenderType: 'Link' | 'Carousel' | 'Collapsed';
  MaxOutside: number | null;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Title = prop.Title;
    this.SubTitle = prop?.SubTitle;
    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop.SubNavTitle;
    this.RenderType = prop.RenderType;
    this.MaxOutside = prop.MaxOutside;
  }
}
export class CardGroupContentModel {

  Title: string;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;
  DefaultView: 'Grid' | 'Scroll' = 'Scroll';
  CardView?: CardViewEnum = CardViewEnum.Default;
  Layout?: SlideLayoutEnum = SlideLayoutEnum.Vertical;
  MaxRows: number | null;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Title = prop.Title;
    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop.SubNavTitle;
    this.CardView = prop?.CardView ?? CardViewEnum.Default;
    this.Layout = prop?.Layout ?? SlideLayoutEnum.Vertical;
    this.DefaultView = prop?.DefaultView ?? 'Scroll';
    this.MaxRows = prop?.MaxRows;
  }
}
export class CarouselGroupContentModel {

  Title: string;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;
  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Title = prop.Title;
    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop.SubNavTitle;
  }
}
export class ContactSlideContentModel {
  Title: string;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;
  Image: {
    AttachementID: string,
    Name: string,
    Location: string,
    URL: string,
    FileSize: number,
    FileExtension: string,
    Resolution: string,
    PreviewName: string,
    Deleted: boolean
  };
  email?: string;
  phone?: string;
  whatsapp?: string;
  website?: string;
  chatPersonName?: string;
  chatPersonIdenedi?: string;
  location?: {
    Label?: string,
    Url?: string
  };

  constructor(prop?: any) {
    if (!prop) {
      this.location = {
        Label: '',
        Url: ''
      };
      this.Image = {
        AttachementID: '',
        Name: '',
        Location: '',
        URL: '',
        FileSize: 0,
        FileExtension: '',
        Resolution: '',
        PreviewName: '',
        Deleted: false
      }
      return;
    }
    this.Title = prop.Title;
    this.phone = prop.phone;
    this.email = prop.email;
    this.whatsapp = prop.whatsapp;
    this.location = prop.location || { Label: '', Url: '' };
    this.website = prop.website;
    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop.SubNavTitle;
    this.chatPersonIdenedi = prop?.chatPersonIdenedi;
    this.chatPersonName = prop?.chatPersonName;
  }
}

export class PriceSlideContentModel {
  Id?: string;
  Title: string;
  Description: string;
  Amount: number;
  Currency: string;
  Unit: string;
  Features: string;
  isRecommended: string;
  ActionUrl?: string;
  ActionLabel?: string;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Id = prop?.Id;  //for pricing build in slide
    this.Title = prop.Title;
    this.Description = prop.Description;
    this.Amount = prop.Amount;
    this.Currency = prop.Currency;
    this.Unit = prop.Unit;
    this.Features = prop.Features;
    this.isRecommended = prop?.isRecommended ?? prop?.IsRecomended ?? false;
    this.ActionUrl = prop?.ActionUrl;
    this.ActionLabel = prop?.ActionLabel;
  }
}

export class PriceGroupContentModel {
  Title: string;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Title = prop.Title;
    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop.SubNavTitle;
  }
}

export class LeadlineSlideContentModel {
  Title: string;
  id: number;
  name: string;
  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Title = prop.Title;
    this.id = prop?.id;
    this.name = prop?.name;
    this.ShowInSubNav = prop.ShowInSubNav ?? ShowInSubNav.Hide;
    this.SubNavTitle = prop.SubNavTitle;
  }
}
export class EspSlideContentModel {
  id?: number;
  name?: string;
  domain?: string;
  baseurl?: string;
  orgid?: string;

  ShowInSubNav: ShowInSubNav = ShowInSubNav.Hide;
  SubNavTitle?: string;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.id = prop?.id;
    this.name = prop?.name;
    this.domain = prop?.domain;
    this.baseurl = prop?.baseurl;
    this.orgid = prop?.orgid;

    this.ShowInSubNav = prop.ShowInSubNav;
    this.SubNavTitle = prop.SubNavTitle;
  }
}
export class OwnerSlideContentModel {
  Idenedi: string;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Idenedi = prop.Idenedi;
  }
}

export class RelatedTopicsSlideContentModel {

  Title: string;
  RenderType: 'Link' | 'Carousel' | 'Collapsed';
  Orientation: 'Horizontal' | 'Vertical';
  MaxOutside: number | null;

  constructor(prop?: any) {
    if (!prop) {
      return;
    }
    this.Title = prop.Title;
    this.RenderType = prop.RenderType;
    this.Orientation = prop.Orientation;
    this.MaxOutside = prop.MaxOutside;
  }
}

export enum AlignTextEnum {
  Default = 'default',
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

export enum CardViewEnum {
  Default = 'Default',
  Overlay = 'Overlay',
  Bullets = 'Bullets',
  Collapsed = 'Collapsed'
}

export enum DescriptionBehaviorEnum {
  OnHover = 'OnHover',
  OnClick = 'OnClick',
  Always = 'Always'
}

export enum CarouselViewEnum {
  Onex = '1x',
  TwoX = '2x',
  FourX = '4x'
}

export class SlideBg {

  private static colors = [
    {
      'main': '#FFFFFF',
      'shade': '#FFFFFF',
    },
    {
      'main': '#008657',
      'shade': '#F2F9F7',
    }, {
      'main': '#62BC16',
      'shade': '#F7FCF3',
    }, {
      'main': '#91C740',
      'shade': '#F9FCF2',
    }, {
      'main': '#3A7ABE',
      'shade': '#F5F8FC',
    }, {
      'main': '#367DFF',
      'shade': '#F5F9FF',
    }, {
      'main': '#6666CC',
      'shade': '#F7F7FD',
    }, {
      'main': '#F26648',
      'shade': '#FEF7F6',
    }, {
      'main': '#F8971D',
      'shade': '#FFFAF4',
    },
    {
      'main': '#B68A35',
      'shade': '#FBF9F5',
    },
  ];

  public static slideBgColors() {
    return this.colors.slice();
  }

  public static isHexCodeNotInColors(hexCode: string): boolean {
    return !this.colors.some(color => color.main === hexCode || color.shade === hexCode);
  }

  public static addColor(color: string) {
    const temp = {
      'main': color,
      'shade': color
    };
    return [temp, ...this.slideBgColors()]
  }
}

export enum SlideLayoutEnum {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
  SSHorizontal = 'horizontal',
  SSVertical = 'vertical',
}

export enum BackGroundImageDesign {
  Default = 'default',
  Underlay = 'underlay',
  Stretch = 'stretch'
}

export enum StepsSlideLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

export enum StepsSlideBulletType {
  Numbers = 'Numbers',
  Bullets = 'Bullets',
  Icons = 'Icons'
}

export enum ImageAlignOptions {
  DescriptionStart = 'DescriptionStart',
  DescriptionCentered = 'DescriptionCentered',
  DescriptionEnd = 'DescriptionEnd'
}
// Image layout start
export enum ImageLayoutEnum {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical'
}
// Image layout end
